import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import indsac_education from "../Images/indsac-education.gif";
import { project_name } from "../Config/config";
import SEO from "../components/SEO";  // 

export default function Education() {
  return (
    <>
      <SEO  // 
        title="AI ERP & CRM for Education Industry | EnteliPro"
        description="EnteliPro offers AI-powered ERP and CRM software for educational institutions. Manage student admissions, enrollment, communications, and alumni relations with intelligent automation."
        keywords="Education ERP Software, AI CRM for Schools, University Management Software, Student Information System, Alumni Management CRM, Education Management Platform"
        canonical="https://www.entelipro.com/Education"
        ogImage="https://www.entelipro.com/static/media/indsac-education.gif"
      />

      <Navbar />
      {/* breadcrumbs */}
      <section className="w3l-inner-banner-main">
        <div className="about-inner inner2">
          <div className="container seen-w3">
            <ul className="breadcrumbs-custom-path">
              <li>
                <Link to="/">
                  Home{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li className="active">Education Industry</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="w3l-content-with-photo-4">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="col-xl-6 cwp4-image ">
                <img
                  src={indsac_education}
                  alt="EnteliPro AI ERP for Education and Academic Institutions"  // 
                  className="img-responsive "
                />
              </div>
              <div className="cwp4-text col-xl-6">
                <h1 className="header-name" style={{ fontSize: "2.3rem", fontWeight: "700", marginBottom: "1rem" }}>  
                  AI ERP & CRM for Education Industry
                </h1>
                <p className="para">
                  Education CRM systems are software applications designed to
                  automate and manage communications with current students,
                  employees, alumni, and prospective applicants. EnteliPro delivers
                  intelligent ERP solutions tailored for schools, colleges, and universities.
                </p>
                <div className="jst-two-coloums mt-4">
                  <div className="icon-text">
                    <p className="para">
                      There are many more processes handled by the CRM, the most
                      important ones are applicant and inquiry management,
                      student communication, admission notifications, enrollment
                      management, analytics, and reporting.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-recent-work-hobbies education-tight">
        <div className="recent-work ">
          <div className="container">
            <div className="left-text">
              <h3>Why Educational Industry Needs CRM</h3>
              <p className="para">
                It is a software application used to automate and handle
                communication with current students, employees, and alumni. All
                this work is done on a single system. Every connection with
                customers is tracked by the customer relationship management
                system in one place. With the help of customer relationship
                management software, you can take feedback from the customers,
                department, and students. Each interaction with your customers
                is tracked by the customer relationship management system.
              </p>
              <br />
            </div>

            <div className="left-text">
              <h3>Why Choose {`${project_name}`} for Educational Purposes?</h3>
              <p className="para">
                {`${project_name}`} is best for its services. It is a smart
                decision to access some businesses. In the educational field
                ether, it is a school or college, the load of work is more. It
                is always a question of how they manage the record of students,
                staff, and other employees in a perfect way. But the customer
                relationship management system solves this problem easily.
              </p>
              <br />
            </div>

            <div className="left-text">
              <h3>Features of ERP For Educational Organization</h3>
              <p className="para">
                1. Centralize students' information. This keeps all the data of
                students, staff, and admission records in one software.
                <br />
                <br />
                2. Manage student inquiries and courses enquired.
                <br />
                <br />
                3. Manage student's enrolment information
                <br />
                <br />
                4. Maximize student's admission efficiency
                <br />
                <br />
                5. Manage whole marketing and students admission lifecycle
                <br />
                <br />
                6. Run emails, SMS marketing, and information campaigns to
                attract the students
                <br />
                <br />
                7. Manage the facility data
                <br />
                <br />
                8. Secure way to run the business
                <br />
                <br />
                9. Cost-efficient
                <br />
                <br />
                10. Real-time reporting and analytical reports
                <br />
                <br />
                11. Use education customer relationship management system on the
                desktop, phone, and tablets
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}